import { apiCall } from "@/shared/services/apiCall.js";
import { errorToast, successToast, helper } from "@/shared/services/helper.js";
import dateTime from "@/shared/services/dateTime.js";
import { createWorker } from 'tesseract.js';
import store  from "@/store/index";
import axios from "axios";
import ocrCheck from "../services/ocrUtr";

const getParentPaymentsMethods = async (reconnectTry, depositAmount) => {
    let parentPaymentsList = null
    let nonSocialStartIndex = null
    try{
        store.dispatch('setGlobalLoader', true);
        console.log(depositAmount)
        let response = await apiCall('get', 'PARENT_PAYMENT_METHODS', null, 'wallet', {amount: depositAmount})
        store.dispatch('setGlobalLoader', false);
        if (response && response.status == 200) {
            if (response?.data?.error) {
                parentPaymentsList = []
                errorToast(response.data.error);
            }else{
                let resData = response.data.data
                let grouped = Object.groupBy(resData, ({ method_name }) => method_name);
                let socialKeys = resData
                    .filter(item => item.method === "social")
                    .map(item => item.method_name);
                let ordered = {};
                socialKeys.forEach(key => {
                    if (grouped[key]) {
                    ordered[key] = grouped[key];
                    delete grouped[key];
                    }
                });
                nonSocialStartIndex = [...new Set(socialKeys)].length;
                Object.assign(ordered, grouped);
                parentPaymentsList = ordered
            } 
            return { data: parentPaymentsList, nonSocialStartIndex: nonSocialStartIndex };
        }
    }catch(error){
        store.dispatch('setGlobalLoader', false);
         if(reconnectTry < 3 && !error) {
            getParentPaymentsMethods(reconnectTry + 1);
            }
            else {
                if (error) {
                    parentPaymentsList = [];
                    errorToast(error[0]);
                    window.router.back();
                }
            }
    }
};


const onUploadImage = async ({
        event,
        depositAmount,
        startTimer,
        resetTimer,
        sbtBtn,
        checkAll
    }) => {
    try {
        const file = event.target.files[0];

        if (!file.type.startsWith('image/')) {
            event.target.value = "";
            errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB');
            return;
        }
        const maxFileSize = 5 * 1024 * 1024; 
        if (file.size > maxFileSize) {
            event.target.value = "";
            errorToast(`Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB`)
            return
        }
        let previewImage = URL.createObjectURL(file)
        let uploadedImage = file
        if (typeof startTimer === 'function') {
            startTimer();
        };

        let manual_utr = null
        manual_utr = await recognize(previewImage, checkAll);
        let tesseract_utr = manual_utr;
        let utrMsg = null;
        if(manual_utr) {
            utrMsg = {
                langKey: 'found-img-utr-found',
                msg:"We find this as UTR Number from uploaded screenshot by you, If it's wrong Kindly make it correct manually for fast deposit."
            };
            if (typeof resetTimer === 'function') {
                resetTimer();
            }
            // helper.scrollToElement(sbtBtn);
            return {
                manual_utr,
                utrMsg,
                uploadedImage,
                previewImage,
                tesseract_utr
            }
        }
        else{
            const autoUtrResult = await autoUtrCheck(uploadedImage, { resetTimer });
            manual_utr = autoUtrResult?.manual_utr;
            utrMsg = autoUtrResult?.utrMsg;
        }
        return {
            manual_utr,
            utrMsg,
            uploadedImage,
            previewImage,
            tesseract_utr
        }
    } catch (error) {
        if(!error){
            errorToast('Error => Corrupted Image , Please Try With New Image')
        }
        else{
            errorToast(error)
        }
        if (typeof resetTimer === 'function') {
            resetTimer();
        } 
    }
}
const autoUtrCheck = async (uploadedImage, { resetTimer }) => {
    try {
        if (!uploadedImage) {
            errorToast("No image found for UTR auto-check.");
            return null;
        }

        const form = new FormData();
        form.append("image", uploadedImage);

        const response = await apiCall("post", "GET_AUTO_UTR", form);

        if (response?.status === 200) {
            if (response?.data?.error) {
                errorToast(response.data.error);
                if (typeof resetTimer === "function") resetTimer();
                return { manual_utr: null, utrMsg: {langKey: null, msg: response.data.error + 'Kindly enter UTR Number manually for fast deposit.'} };
            }

            let manual_utr = null;
            let utrMsg = null;

            if (response.data.utr != null) {
                manual_utr = response.data.utr;
                utrMsg = {
                    langKey: "found-img-utr-found",
                    msg: "We find this as UTR Number from uploaded screenshot by you, If it's wrong Kindly make it correct manually for fast deposit."
                };
            } else {
                manual_utr = null;
                utrMsg = {
                    langKey: "found-img-utr-not-found",
                    msg: "We didn't find any UTR Number from uploaded screenshot by you, Kindly enter UTR Number manually for fast deposit."
                };
            }

            if (typeof resetTimer === "function") resetTimer();

            return { manual_utr, utrMsg };
        }
    } catch (error) {
        if (typeof resetTimer === "function") resetTimer();
        errorToast(error[0] || "Something went wrong while fetching UTR.");
        return { manual_utr: null, utrMsg: {langKey: null, msg: "Something went wrong while fetching UTR, Kindly enter UTR Number manually for fast deposit."}};
    }
};
const recognize = async (prevImgs, checkAll) => {
     try {
        const img = prevImgs;
        const worker = await createWorker('eng');
        let { data: { text } } = await worker.recognize(img);
        await worker.terminate();
        if (typeof checkAll === 'function') {
            return checkAll(text);
        }
    } catch (e) {
        console.log('recog',e)
        errorToast(e)
        throw e;
    }
}

const submitDepositAmount = async ({
        accountDetails,
        uploadedImage,
        depositAmount,
        manual_utr,
        has_edited_utr,
        removeImage
    }) => {
    try {
        if (!uploadedImage || uploadedImage == null) {
            
            // errorToast('Please upload image');
            return
        }     
        if (!depositAmount || depositAmount == null) {
            errorToast('Please Enter Deposit Amount');
            return
        }
        store.dispatch('setGlobalLoader', true);
        const imageUrl = await prepareIconUpload(uploadedImage, 'payment_method')
        let walletDepositData = {
            "amount": depositAmount,
            "transaction_id": manual_utr,
            "transaction_image_url": imageUrl,
            "account_index": accountDetails.master_account_id,
            "client_created_date": dateTime.sportItemDate(accountDetails.created_at, 'YYYY-MM-DD HH:mm:ss'),
            "type": "client_deposit",
            'has_edited_utr':has_edited_utr,
            "multiplier_value": accountDetails.multiplier_value
        }

        let response = await apiCall('post', 'WALLET_DEPOSIT', walletDepositData, 'wallet')
        store.dispatch('setGlobalLoader', false);
        if (response && response.status == 200) {
            if (response?.data?.error) {
                errorToast(response.data.error);
            }else{
                window.router.push('/');
                successToast(response?.data?.message)
                if (typeof resetTimer === 'function') {
                    removeImage();
                }
            } 
            // return { data: parentPaymentsList};
        }
    } catch (error) {
        store.dispatch('setGlobalLoader', false);
        if (error) {
            errorToast(error[0]);
        }
    }
}

const prepareIconUpload = async (file, type) => {
        if (!file) return;
        const allowedTypes = [
            'image/jpeg',
            'image/png',
            'image/gif',
            'image/bmp',
            'image/webp',
            'image/svg+xml',
            'text/csv',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ];
        if (!allowedTypes.includes(file.type)) {
            return errorToast('Invalid file type');
        }
        try {
            const payload = {
                file_type: file.type,
                file_size: Math.round(file.size / 1024), // in KB
                file_name: file.name,
                type
            };

            const { data } = await apiCall('post', 'UPLOAD_AND_FETCH_QR_DATA', payload, 'wallet');
            if (!data?.success) {
                errorToast(data?.message || 'Failed to get upload URL');
                throw new Error(data?.message || 'Failed to get upload URL');
            }

            return await uploadIconToS3(data.data.url, file);
        } catch (err) {
            if (err.message.includes('Aborted(-1)')) {
                errorToast('File seems corrupted and cannot be uploaded');
            } else {
                errorToast(err || 'File upload failed');
            }
            console.error('prepareIconUpload error:', err);
            throw err;
        }
    };

    const uploadIconToS3 = async (s3Url, file) => {
        try {
            const response = await axios.put(s3Url, file, {
                headers: {
                    'Content-Type': file.type,
                    'x-amz-acl': 'public-read'
                }
            });
            console.log('S3 upload response:', response.status, response.statusText);
            return s3Url.split("?")?.[0]
        } catch (err) {
            errorToast('S3 upload failed:', err.response?.status, err.response?.data || err.message)
            console.error('S3 upload failed:', err.response?.status, err.response?.data || err.message);
            throw new Error('Failed to upload icon to storage');
        }
    };

    const getPaymentGatewayUrl = async (amount, master_account_id) => {
        try {
            const response  = await apiCall('get', 'PAYMENT_GATEWAY', null, 'wallet', {amount, master_account_id})
            if (response?.status == 200) {
                if (!response?.data?.success) {
                    errorToast(response?.data?.error);
                } else {
                    if (response?.data?.data?.url) {
                        window.location.href = response?.data?.data?.url;
                    }
                }
                store.dispatch('setGlobalLoader', false);
            }
        } catch (error) {
            store.dispatch('setGlobalLoader', false);
            if (error) {
                errorToast(error[0]);
            }
        }
    };

export {
    getParentPaymentsMethods,
    onUploadImage,
    submitDepositAmount,
    ocrCheck,
    getPaymentGatewayUrl
}